import { default as Tab } from './Tab';

const EXPORT = { Tab };

export default EXPORT;
